import React, { Component } from 'react';
import config from '../../config';
import Helmet from 'react-helmet';

export default class Copyright extends Component {
  render() {
    return (
      <div className="container">
        <Helmet
          title="Acceptable Use Policy"
          link={[{ rel: 'canonical', href: config.baseUrl + '/aup' }]}
        />

        <h1 className="lato-bold text-uppercase text-center aside-text mt mb">
          Acceptable Use Policy
        </h1>

        <div className="panel p++">
          <p className="lato-regular">
            <strong>
              PLEASE READ THE TERMS OF THIS POLICY CAREFULLY BEFORE USING THE
              SITE
            </strong>
          </p>

          <h3 className="lato-bold mt mb">What's in these terms?</h3>
          <p className="lato-regular">
            This acceptable use policy sets out the content standards that apply
            when you upload content to our site, make contact with other users
            on our site, link to our site, or interact with our site in any
            other way.
          </p>

          <h3 className="lato-bold mt mb">Who we are and how to contact us</h3>
          <p className="lato-regular">
            <a href="https://www.twine.net">www.twine.net</a> is a site operated
            by Clowdy Limited, trading as <strong>"Twine"</strong> (
            <strong>"We"</strong>). We are registered in England and Wales under
            company number 08195808 and have our registered office at 3rd Floor,
            86-90 Paul Street, London EC2A 4NE. We are a limited company.
          </p>
          <p className="lato-regular">
            To contact us, please visit our{' '}
            <a href="https://twine.net/support">Support</a> page.
          </p>

          <h3 className="lato-bold mt mb">
            By using our site you accept these terms
          </h3>
          <p className="lato-regular">
            By using our site, you confirm that you accept the terms of this
            policy and that you agree to comply with them.
          </p>
          <p className="lato-regular">
            If you do not agree to these terms, you must not use our site.
          </p>
          <p className="lato-regular">
            We recommend that you print a copy of these terms for future
            reference.
          </p>

          <h3 className="lato-bold mt mb">
            There are other terms that may apply to you
          </h3>
          <ul>
            <li>
              <p className="lato-regular">
                Our <a href="/terms">Terms and Conditions</a> also apply to your
                use of our site.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Our <a href="/privacy">Privacy Policy</a>.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Our <a href="/cookies">Cookie Policy</a>, which sets out
                information about the cookies on our site.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                If you offer to sell services or goods via our site, or you
                purchase services or goods via our site, our{' '}
                <a href="/platform-terms">Platform Terms of Use</a> will apply.
              </p>
            </li>
          </ul>

          <h3 className="lato-bold mt mb">
            We may make changes to the terms of this policy
          </h3>
          <p className="lato-regular">
            We amend these terms from time to time. Every time you wish to use
            our site, please check these terms to ensure you understand the
            terms that apply at that time. This version is dated{' '}
            <strong>7 August 2026</strong>.
          </p>

          <h3 className="lato-bold mt mb">Prohibited uses</h3>
          <p className="lato-regular">
            You may use our site only for lawful purposes. You may not use our
            site:
          </p>
          <ul>
            <li>
              <p className="lato-regular">
                In any way that breaches any applicable local, national or
                international law or regulation.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                In any way that is unlawful or fraudulent, or has any unlawful
                or fraudulent purpose or effect.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                For the purpose of harming or attempting to harm minors in any
                way.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                To bully, insult, intimidate or humiliate any person.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                To send, knowingly receive, upload, download, use or re-use any
                material which does not comply with our content standards below.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                To transmit, or procure the sending of, any unsolicited or
                unauthorised advertising or promotional material or any other
                form of similar solicitation (spam).
              </p>
            </li>
            <li>
              <p className="lato-regular">
                To send excessive, duplicative or low-value messages to any
                other user, including follow-up messages after application.
                Follow-up messages are permitted where they are respectful and
                add genuine substance - for example, sharing relevant work
                samples, clarifying or improving your original pitch, or
                answering a question. Messages that add nothing new (for
                example, &quot;hello&quot;, &quot;are you there&quot; or
                &quot;have you seen my pitch&quot;), that substantially repeat
                an earlier message, or that pressure another user for a response
                will be treated as spam and a breach of this policy, whether or
                not any individual message is itself offensive. Twine will
                determine, in its reasonable opinion, whether messaging conduct
                breaches this policy, having regard to the frequency, content
                and tone of the messages taken as a whole.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                To knowingly transmit any data, send or upload any material that
                contains viruses, Trojan horses, worms, time-bombs, keystroke
                loggers, spyware, adware or any other harmful programs or
                similar computer code designed to adversely affect the operation
                of any computer software or hardware.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                To post project briefs, browse profiles, contact users, or
                otherwise use our site for the purpose of operating, promoting,
                recruiting for, or directing users toward any product or service
                that competes with Twine, including any other freelance
                marketplace, talent-matching platform, or service that connects
                freelancers or creators with work opportunities.
              </p>
            </li>
          </ul>

          <p className="lato-regular">You also agree:</p>
          <ul>
            <li>
              <p className="lato-regular">
                Not to reproduce, duplicate, copy or re-sell any part of our
                site in contravention of the provisions of our{' '}
                <a href="/terms">Terms and Conditions</a>.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Not to access without authority, interfere with, damage or
                disrupt;
              </p>
            </li>
            <li>
              <p className="lato-regular">any part of our site;</p>
            </li>
            <li>
              <p className="lato-regular">
                any equipment or network on which our site is stored;
              </p>
            </li>
            <li>
              <p className="lato-regular">
                any software used in the provision of our site; or
              </p>
            </li>
            <li>
              <p className="lato-regular">
                any equipment or network or software owned or used by any third
                party.
              </p>
            </li>
          </ul>

          <h3 className="lato-bold mt mb">Competing Services</h3>
          <p className="lato-regular">
            Our site is provided for genuine businesses and individuals seeking
            to hire or provide freelance services. It is not intended for use by
            competitors, or by any party seeking to recruit our users, gather
            data on our users or pricing, or promote a competing platform or
            service. Twine reserves the right, in its sole discretion, to remove
            any project brief, account, or content that it reasonably believes
            is intended for such a purpose, and to suspend or terminate the
            account(s) involved, without refund except where required by law.
            This applies regardless of the number or type of accounts used to
            submit such content.
          </p>

          <h3 className="lato-bold mt mb">Interactive services</h3>
          <p className="lato-regular">
            We may from time to time provide interactive services on our site{' '}
            <strong>("interactive services")</strong>, including, without
            limitation:
          </p>
          <ul>
            <li>
              <p className="lato-regular">Chat rooms.</p>
            </li>
            <li>
              <p className="lato-regular">Bulletin boards.</p>
            </li>
          </ul>
          <p className="lato-regular">
            Where we do provide any interactive service, we will provide clear
            information to you about the kind of service offered, if it is
            moderated and what form of moderation is used (including whether it
            is human or technical).
          </p>
          <p className="lato-regular">
            We will do our best to assess any possible risks for users (and in
            particular, for children) from third parties when they use any
            interactive service provided on our site, and we will decide in each
            case whether it is appropriate to use moderation of the relevant
            service (including what kind of moderation to use) in the light of
            those risks. However, we are under no obligation to oversee, monitor
            or moderate any interactive service we provide on our site, and we
            expressly exclude our liability for any loss or damage arising from
            the use of any interactive service by a user in contravention of our
            content standards, whether the service is moderated or not.
          </p>
          <p className="lato-regular">
            The use of any of our interactive services by a minor is subject to
            the consent of their parent or guardian. We advise parents who
            permit their children to use an interactive service that it is
            important that they communicate with their children about their
            safety online, as moderation is not fool proof. Minors who are using
            any interactive service should be made aware of the potential risks
            to them.
          </p>
          <p className="lato-regular">
            Where we do moderate an interactive service, we will normally
            provide you with a means of contacting the moderator, should a
            concern or difficulty arise.
          </p>

          <h3 className="lato-bold mt mb">Content standards</h3>
          <p className="lato-regular">
            These content standards apply to any and all material which you
            contribute to our site (<strong>"Contribution"</strong>), and to any
            interactive services associated with it.
          </p>
          <p className="lato-regular">
            The Content Standards must be complied with in spirit as well as to
            the letter. The standards apply to each part of any Contribution as
            well as to its whole.
          </p>
          <p className="lato-regular">
            Twine will determine, in its discretion, whether a Contribution
            breaches the Content Standards.
          </p>
          <p className="lato-regular">
            <strong>A Contribution must:</strong>
          </p>
          <ul>
            <li>
              <p className="lato-regular">
                Be accurate (where it states facts).
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Be genuinely held (where it states opinions).
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Comply with the law applicable in England and Wales and in any
                country from which it is posted.
              </p>
            </li>
          </ul>
          <p className="lato-regular">
            <strong>A Contribution must not:</strong>
          </p>
          <ul>
            <li>
              <p className="lato-regular">Be defamatory of any person.</p>
            </li>
            <li>
              <p className="lato-regular">
                Be obscene, offensive, hateful or inflammatory.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Bully, insult, intimidate or humiliate.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Promote sexually explicit material.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Include child sexual abuse material.
              </p>
            </li>
            <li>
              <p className="lato-regular">Promote violence.</p>
            </li>
            <li>
              <p className="lato-regular">
                Promote discrimination based on race, sex, religion,
                nationality, disability, sexual orientation or age.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Infringe any copyright, database right or trade mark of any
                other person.
              </p>
            </li>
            <li>
              <p className="lato-regular">Be likely to deceive any person.</p>
            </li>
            <li>
              <p className="lato-regular">
                Breach any legal duty owed to a third party, such as a
                contractual duty or a duty of confidence.
              </p>
            </li>
            <li>
              <p className="lato-regular">Promote any illegal activity.</p>
            </li>
            <li>
              <p className="lato-regular">Be in contempt of court.</p>
            </li>
            <li>
              <p className="lato-regular">
                Be threatening, abuse or invade another's privacy, or cause
                annoyance, inconvenience or needless anxiety.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Be likely to harass, upset, embarrass, alarm or annoy any other
                person.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Impersonate any person, or misrepresent your identity or
                affiliation with any person.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Give the impression that the Contribution emanates from Twine,
                if this is not the case.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Advocate, promote, incite any party to commit, or assist any
                unlawful or criminal act such as (by way of example only)
                copyright infringement or computer misuse.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Contain a statement which you know or believe, or have
                reasonable grounds for believing, that members of the public to
                whom the statement is, or is to be, published are likely to
                understand as a direct or indirect encouragement or other
                inducement to the commission, preparation or instigation of acts
                of terrorism.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Contain any advertising or promote any services or web links to
                other sites.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Misrepresent content generated wholly or partly by artificial
                intelligence as original human-created work, or omit to disclose
                such use where disclosure is required by our{' '}
                <a href="/engagement-terms">Engagement Terms</a>.
              </p>
            </li>
          </ul>

          <h3 className="lato-bold mt mb">Breach of this policy</h3>
          <p className="lato-regular">
            When we consider that a breach of this acceptable use policy has
            occurred, we may take such action as we deem appropriate.
          </p>
          <p className="lato-regular">
            Failure to comply with this acceptable use policy constitutes a
            material breach of the <a href="/terms">Terms and Conditions</a>{' '}
            upon which you are permitted to use our site, and may result in our
            taking all or any of the following actions:
          </p>
          <ul>
            <li>
              <p className="lato-regular">
                Immediate, temporary or permanent withdrawal of your right to
                use our site.
              </p>
            </li>
            <li>
              <p className="lato-regular">
                Immediate, temporary or permanent removal of any Contribution
                uploaded by you to our site.
              </p>
            </li>
            <li>
              <p className="lato-regular">Issue of a warning to you.</p>
            </li>
            <li>
              <p className="lato-regular">
                Legal proceedings against you for reimbursement of all costs on
                an indemnity basis (including, but not limited to, reasonable
                administrative and legal costs) resulting from the breach.
              </p>
            </li>
            <li>
              <p className="lato-regular">Further legal action against you.</p>
            </li>
            <li>
              <p className="lato-regular">
                Disclosure of such information to law enforcement authorities as
                we reasonably feel is necessary or as required by law.
              </p>
            </li>
          </ul>
          <p className="lato-regular">
            We exclude our liability for all action we may take in response to
            breaches of this acceptable use policy. The actions we may take are
            not limited to those described above, and we may take any other
            action we reasonably deem appropriate.
          </p>

          <h3 className="lato-bold mt mb">
            Which country's laws apply to any disputes?
          </h3>
          <p className="lato-regular">
            If you are a consumer, please note that the terms of this policy,
            its subject matter and its formation are governed by English law.
            You and we both agree that the courts of England and Wales will have
            exclusive jurisdiction except that if you are a resident of Northern
            Ireland you may also bring proceedings in Northern Ireland, and if
            you are resident of Scotland, you may also bring proceedings in
            Scotland.
          </p>
          <p className="lato-regular">
            If you are a business, the terms of this policy, its subject matter
            and its formation (and any non-contractual disputes or claims) are
            governed by English law. We both agree to the exclusive jurisdiction
            of the courts of England and Wales.
          </p>

          <hr />

          <p className="lato-regular">
            For further terms of using Twine, please read our{' '}
            <a href="/terms">Terms and Conditions</a>.
          </p>
        </div>
      </div>
    );
  }
}
